import { ReactNode, useEffect } from 'react';

import { useGetUser } from '@/api';
import { TrackingParams, TrackingParamsKeys } from '@/api/types';
import { useModalStore } from '@/store';

interface IAppInitContainerProps {
    children: ReactNode;
}

export const AppInitContainer = ({ children }: IAppInitContainerProps) => {
    const { setIsPurchaseOpen } = useModalStore();

    useGetUser();

    useEffect(() => {
        if (localStorage.getItem('preliminaryReservedMsisdn')) {
            setIsPurchaseOpen(true);
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const trackingParams: Partial<TrackingParams> = {
            utm_source: undefined,
            utm_medium: undefined,
            utm_campaign: undefined,
            utm_content: undefined,
            utm_term: undefined,
            invited_by: undefined,
            place_id: undefined,
            yclid: undefined,
            gclid: undefined,
        };

        for (const [key, value] of params) {
            if (key in trackingParams) {
                trackingParams[key as TrackingParamsKeys] = value;
            }
        }

        if (Object.values(trackingParams).some(value => !!value)) {
            localStorage.setItem('trackingParams', JSON.stringify(trackingParams));
        }
    }, []);

    return <>{children}</>;
};
